import {Component, OnDestroy, OnInit, Injector} from '@angular/core';
import {JhiAlertService, AlertMessage} from 'ng-jhipster';

@Component({
  selector: 'app-alert',
  template: ` <div class="alerts" role="alert">
    <div *ngFor="let alert of alerts" [ngClass]="setClasses(alert)">
      <div *ngIf="alert && alert.type && alert.msg" [ngClass]="alert.type">
        <pre [innerHTML]="alert.msg"></pre>
      </div>
    </div>
  </div>`,
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent implements OnInit, OnDestroy {
  alerts: AlertMessage[] = [];

  alertService: JhiAlertService;

  constructor(private injector: Injector) {
    // defer to avoid cyclic construction issues
    setTimeout(() => (this.alertService = this.injector.get(JhiAlertService)));
  }

  ngOnInit() {
    // get returns backing array; already populated via service pushes
    if (this.alertService) {
      this.alerts = this.alertService.get();
    }
  }

  setClasses(alert) {
    return {
      toast: !!alert.toast,
      [alert.position]: true,
    };
  }

  ngOnDestroy() {
    this.alerts.length = 0;
  }
}
